import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { themeStyle } from '@repo/ui/theming';
import IconChevronDown from '@repo/ui-icons/IconChevronDown';
import { H5 } from '@repo/ui-kit/components/core/Typography';

import HeaderLayout from 'components/HeadMenu/HeaderLayout/HeaderLayout';
import HeaderPopover from 'components/HeadMenu/HeaderPopover/HeaderPopover';
import { Backdrop } from 'components/HeadMenu/HeaderPopover/styles';
import { NavigationItem } from 'components/HeadMenu/types';

import {
  DropdownList,
  HeaderButton,
  HoverBlock,
  ItemWrapper,
  Wrapper,
} from './styles';

const NavigationItemComponent: React.FC<{
  navigationItem: NavigationItem;
}> = ({ navigationItem }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <Backdrop visible={isOpen} />
      <Wrapper
        as="li"
        onClick={() => setIsOpen((o) => !o)}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <ItemWrapper color={themeStyle.varInkMedium}>
          <HoverBlock />
          <HeaderButton>
            <H5 as="span">{navigationItem.label}</H5>
            <IconChevronDown
              activeColor={themeStyle.varInkMain}
              color={themeStyle.varInkMedium}
              size={16}
              state={isOpen ? 'active' : 'default'}
            />
          </HeaderButton>
        </ItemWrapper>
        <HeaderPopover visible={isOpen}>
          <DropdownList>
            <HeaderLayout navigationItems={navigationItem.items} />
          </DropdownList>
        </HeaderPopover>
      </Wrapper>
    </>
  );
};

export default withEventScope(NavigationItemComponent, {
  module: 'navigationItem',
});
